export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-06.edf31641.png";